import { useCurrentInstance } from '@meteor/state';
import { useLayoutEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../paths';

export let InstanceRedirect = () => {
  let instance = useCurrentInstance();
  let navigate = useNavigate();

  let navigatedRef = useRef(false);
  useLayoutEffect(() => {
    if (!instance.data || navigatedRef.current) return;

    navigatedRef.current = true;
    navigate(Paths.workflows(instance.data), { replace: true });
  }, [instance.data]);

  return null;
};
